// extracted by mini-css-extract-plugin
export default {"container":"ColorCellRenderer_container__CSTxt","colorTag":"ColorCellRenderer_colorTag__5nFGI","valueText":"ColorCellRenderer_valueText__yd7Cb"};